import React from "react";
import PropTypes from "prop-types";

import LabeledContent from "@components/LabeledContent";

import { css } from "@oddcommon/utils";
import styles from "./TextAndImageBlock.module.scss";

export default function TextAndImageBlock({
  textLabel,
  text,
  image: { src, alt, attribution },
  layout,
}) {
  return (
    <div className={css(styles.base, styles[`layout-${layout}`])}>
      <LabeledContent label={textLabel} className={css(styles.textContainer)}>
        <div className={styles.text}>{text}</div>
      </LabeledContent>
      <div className={styles.imageWrapper}>
        {src.indexOf(".mp4") == -1 && (
          <img className={styles.image} src={src + "?fm=webp&w=1920&q=80"} alt={alt} />
        )}
        {src.indexOf(".mp4") > -1 && (
          <video className={styles.image} src={src} alt={alt} muted autoPlay playsInline loop />
        )}
        {attribution?.trim?.() && <div className={styles.attribution}>{attribution}</div>}
      </div>
    </div>
  );
}

TextAndImageBlock.propTypes = {
  textLabel: PropTypes.node,
  text: PropTypes.node.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    attribution: PropTypes.node,
  }).isRequired,
  layout: PropTypes.oneOf(["left", "right"]),
};
TextAndImageBlock.defaultProps = {
  layout: "left",
};
